import React, { Component } from "react";
import client from "@culturehq/client";
import { Icon, PlainButton, Success } from "@culturehq/components";

import { useProfile } from "app/context";
import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import Event from "components/events/Event";
import ChqModalConfirmDelete from "../ChqModalConfirmDelete";

const canDelete = (photo, profile) => {
  if (!photo) {
    return null;
  }

  const event = new Event(photo.event);
  return event.isUserHostOrAdmin(profile) || (profile.id === photo.uploader.id);
};

class DeletePhotoContext extends Component {
  state = { success: false, error: false };

  handleClick = async () => {
    this.setState({ success: false, error: false });
    const { photo, onDelete } = this.props;

    if (!photo || !photo.id) {
      return;
    }

    try {
      await client.deletePhoto({ photoId: photo.id });
      this.setState({ success: false, error: false });

      if (onDelete) {
        onDelete(photo);
      }
    } catch (error) {
      this.setState({ success: false, error });
    }
  };

  render() {
    const { photo, profile } = this.props;
    const { success, error } = this.state;
    const { event } = photo;

    if (!canDelete(photo, profile)) {
      return null;
    }

    return (
      <ChqModalConfirmDelete
        accept={t("Delete Photo")}
        className="gallery-delete--modal"
        onAccept={this.handleClick}
        trigger={onTrigger => (
          <PlainButton aria-label={t("Delete")} onClick={onTrigger}>
            <Icon icon="trash-a" />
          </PlainButton>
        )}
      >
        <p className="form-description">
          <Trans>Are you sure you want to delete this photo? This action cannot be undone.</Trans>
        </p>

        <img src={photo.image.largeUrl} alt={event.name} />
        <br />
        <p>
          <strong>Event:</strong> {event.name}
        </p>

        {error && <ErrorMessage error={error} />}

        {success && (
          <Success><Trans>Success!</Trans></Success>
        )}
      </ChqModalConfirmDelete>
    );
  }
}

const DeletePhoto = props => {
  const { profile } = useProfile();

  return <DeletePhotoContext {...props} profile={profile} />;
};

export default DeletePhoto;
